import React, { useContext } from 'react';
import { Box, Button, Typography } from '@mui/material';

import { RegistrationContext } from './RegistrationContainer';

const ActivateAccount = () => {
  const { docusignReturnedEmailAddress } = useContext(RegistrationContext);

  return (
    <Box
      sx={{
        p: 3,
        border: '1px solid #232323',
        borderRadius: 2,
      }}
    >
      <Typography variant="body2" gutterBottom>
        Thank you for signing up on the ENS Portal.
      </Typography>

      <Typography variant="body2" gutterBottom>
        The next steps are:
      </Typography>

      <ol style={{ textAlign: 'left', margin: '0 auto', display: 'inline-block' }}>
        <li>
          Activate your account and set your password. We have sent details of these steps to your email address{' '}
          <strong>{docusignReturnedEmailAddress}</strong>.
        </li>
        <li>Click the following button to access the CABIE ENS Portal knowledge base.</li>
      </ol>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 3,
        }}
      >
        <Button
          variant="contained"
          sx={{
            mt: 3,
            backgroundColor: '#FFA726',
            color: 'black',
            '&:hover': {
              backgroundColor: '#FB8C00',
            },
            border: '1px solid black',
            px: 4,
          }}
          onClick={() =>
            window.open(
              process.env.REACT_APP_KNOWLEDGE ||
                'https://www.eori.uk/_hcms/mem/login?redirect_url=https%3A%2F%2Fwww.eori.uk%2Fcustoms-knowledge',
              '_blank'
            )
          }
        >
          Access ENS KB
        </Button>
      </Box>
      {/* <Typography variant="body1" sx={{ mt: 2 }}>
           Bookmark <a href="https://www.eori.uk/_hcms/mem/login?redirect_url=https%3A%2F%2Fwww.eori.uk%2Fcustoms-knowledge" target="_blank" rel="noopener noreferrer">
           CABIE ENS Portal
           </a> for quick access to the portal.
         </Typography> */}
    </Box>
  );
};

export default ActivateAccount;
